import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { FileTypes } from '@guryou/core';
import { Block, DefaultText, FlexColumn, ImgIcon, PaperBlock, SmallText, Spinner, TextBox } from '@guryou/html-components';
import { stateIsLoading, useSharedMedia } from '@guryou/redux';
import { stripHtml } from '@guryou/utils';
import { Card, CardContent, CardMedia } from '@material-ui/core';

const MediaBlock = ({ setLs }) => {
  const { t } = useTranslation();
  const media = useSharedMedia(FileTypes.image);
  const [filter, setFilter] = useState('');
  const blockRef = useRef(null);

  // The gallery mounts at the bottom of whichever form opened it, well below the "browse"
  // button and the image preview — so opening it looked like nothing had happened, and after
  // picking a file you were left at the bottom with no sight of the image you just chose.
  // Scroll to it on open, and back to where you were on close (selection unmounts this).
  useEffect(() => {
    const origin = typeof window !== 'undefined' ? window.scrollY : 0;
    blockRef.current?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });

    return () => {
      window?.scrollTo?.({ top: origin, behavior: 'smooth' });
    };
  }, []);

  const filterFunction = item => {
    const title = item.title || item.name;
    return item.type === FileTypes.image && item?.name.split('.')[1] !== FileTypes.gif && title?.toLowerCase().includes(filter?.toLowerCase());
  };

  return (
    <div ref={blockRef}>
      <PaperBlock display="flex" xs={12} flexWrap="wrap" justifyContent="flex-start" alignItems="center" padding={1} margin={2}>
        {stateIsLoading(media) ? (
          <Spinner />
        ) : media.data.length !== 0 ? (
          <>
            <Block xs={12} margin={2} display="flex" alignItems="center" justifyContent="right">
              <TextBox xs={4} placeholder={t('GENERAL.search')} onChange={e => setFilter(e)} />
            </Block>
            {media.data.filter(filterFunction).map(file => (
              <Card
                key={file.id}
                style={{ height: '220px', justifyContent: 'start' }}
                onClick={() => {
                  setFilter('');
                  setLs(prev => ({ ...prev, file, chooseFile: false }));
                }}
              >
                <CardMedia image={file.thumbnailUrl} title={file.title || file.name} />
                <CardContent style={{ overflowY: 'scroll', display: 'block' }}>
                  <FlexColumn justifyContent="center" alignItems="flex-start" margin={0}>
                    <ImgIcon style={{ color: colors.black }} />
                    <DefaultText>{file.title || file.name}</DefaultText>
                    <SmallText marginTop={2}>{stripHtml(file.description)}</SmallText>
                  </FlexColumn>
                </CardContent>
              </Card>
            ))}
          </>
        ) : (
          <Block xs={12} display="flex" alignItems="center" justifyContent="center" padding={5}>
            <DefaultText textAlign="center">{t('MEDIA_GALLERY.noItems')}</DefaultText>
          </Block>
        )}
      </PaperBlock>
    </div>
  );
};

export default MediaBlock;
